<app-wide-sidebar>
  @if (mobileTemplate$ | async; as mobileTemplate) {
    <div class="form-group m-t-16">
      <div class="form-row">
        <div class="form-input">
          <input id="task-title" class="form-control" type="text"
            placeholder="Title" [(ngModel)]="mobileTemplate.name" (change)="nameChanged($event)">
          <label class="label-styling" for="task-title">Name</label>
        </div>
      </div>
    </div>
    <div class="checkboxes-grid">
      <div class="form-row">
        <div class="form-check">
          <label>
            <input type="checkbox" [checked]="mobileTemplate.is_showing_event_date"
              (change)="switchEventDate($event)"/>
            <span class="label">{{ ('Ticket_Template_List.Showing_Event_Date' | trans) | async }}</span>
          </label>
        </div>
      </div>
      <div class="form-row">
        <div class="form-check">
          <label>
            <input type="checkbox" [checked]="mobileTemplate.is_showing_expiry_date"
              (change)="switchExpiryDate($event)"/>
            <span class="label">{{ ('Ticket_Template_List.Showing_Expiry_Date' | trans) | async }}</span>
          </label>
        </div>
      </div>
      <div class="form-row">
        <div class="form-check">
          <label>
            <input type="checkbox" [checked]="mobileTemplate.is_showing_price"
              (change)="switchPrice($event)"/>
            <span class="label">{{ ('Ticket_Template_List.Showing_Price' | trans) | async }}</span>
          </label>
        </div>
      </div>
      <div class="form-row">
        <div class="form-check">
          <label>
            <input type="checkbox" [checked]="mobileTemplate.is_showing_purchase_date"
              (change)="switchPurchaseDate($event)"/>
            <span class="label">{{ ('Ticket_Template_List.Showing_Purchase_Date' | trans) | async }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="m-b-24 m-t-24">
      <div class="form-row">
        <div class="form-input">
          <cm-color-picker data-color="{{mobileTemplate.primary_background_color}}"
            (change)="googleWalletColorChanged($event)" data-hide-alpha="true"
          data-label="{{('Ticket_Template_List.Google_Wallet_Color' | trans) | async}}"></cm-color-picker>
        </div>
      </div>
    </div>
    <div class="row m-t-16">
      <span [innerText]="('Mobile_Template_Editor.Banner.Size' | trans) | async"></span>
    </div>
    <div class="m-t-16">
      <cm-file-upload data-max-file-size="1048576" data-display="Banner/Logo" name="image"
        (change)="uploadBannerImage($event)">
      </cm-file-upload>
    </div>
    <div class="row m-t-16">
      <span [innerText]="('Mobile_Template_Editor.Background.Size' | trans) | async"></span>
    </div>
    <div class="m-t-16">
      <cm-file-upload data-max-file-size="1048576" data-display="Background" name="imagev2"
        (change)="uploadBackgroundImage($event)">
      </cm-file-upload>
    </div>
    <div class="actions">
      <cm-button data-button-type="text"
        data-button-style="secondary"
        [attr.data-label]="('Generic.Forms.Close_Button' | trans) | async"
      (click)="onCloseClick()"></cm-button>
      <cm-button data-button-type="icon-text"
        data-button-style="cta"
        data-icon="save"
        [attr.data-label]="('Generic.Forms.Save_Button' | trans) | async"
      (click)="onSaveClick()"></cm-button>
    </div>
  }
</app-wide-sidebar>

@if (mobileTemplate) {
  <div class="mobile-template-example" [ngClass]="{'hidden': loadingEditor}" id="mobile-template-example"></div>
}
@if (loadingEditor) {
  <div class="load-indicator">
    <cm-indicator></cm-indicator>
  </div>
}
